import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  overTimeHistoryForEdit: undefined,
  overTimeDetails: undefined,
  error: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const overTimeHistorySlice = createSlice({
  name: "overTimeHistory",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    allOverTimeHistoryFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    allOverTimeDetailsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.overTimeDetails = entities;
      state.totalCount = totalCount;
    },

    // getrequisitonById
    overTimeHistoryFetched: (state, action) => {
      state.actionsLoading = false;
      state.overTimeHistoryForEdit = action.payload.overTimeHistoryForEdit;
      state.error = null;
    },
  },
});
